"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var dealersListContainerStyles = styles_1.makeStyles(function (theme) {
    var _a;
    return ({
        listContainer: (_a = {
                width: '100%',
                maxWidth: 300,
                boxShadow: 'none'
            },
            _a[theme.breakpoints.down('sm')] = {
                maxWidth: 'none',
                marginTop: 30,
            },
            _a),
    });
}, { name: 'Checkout_DealersListContainer' });
exports.default = dealersListContainerStyles;
